import type { Command } from 'prosemirror-state';

export const removeVideoAttributesCommand = (position: number): Command =>
  function (state, dispatch) {
    const tr = state.tr;
    const node = tr.doc.nodeAt(position);
    if (!node) return false;

    tr.delete(position, position + node.nodeSize);

    if (!tr) return false;
    if (dispatch) dispatch(tr);
    return true;
  };
